import styled from "styled-components";

export const Wrapper = styled.div`
  .header-tag {
    background: linear-gradient(to right, #2b4152, #b0e2fb);
    border-radius: 5px;
    h4 {
      font-size: 24px;
      color: white;
      text-transform: uppercase;
      padding: 8px;
    }
  }
  .heading-six {
    label {
      font-weight: 600;
      font-size: 15px;
      color: gray;
    }
  }
  .information-card {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 18px;
  }
  .CalendarIcon {
    font-size: 18px;
  }
  .main-container {
    display: flex;
    justify-content: center;
  }
  .main-calendar-data {
    background: #e9ecef;
    padding: 25px 30px;
    box-shadow: 0px 0px 15px 1px #00000066;
    border-radius: 15px;
  }
  .time-data {
    background: #131f28;
    padding: 20px 30px;
    box-shadow: 0px 0px 15px 1px #00000066;
    position: relative;
    left: 10px;
    border-radius: 15px;
    overflow: auto;
    height: 240px;
  }
  .time-data::-webkit-scrollbar-track {
    background-color: #e9ecef;
  }
  .time-data::-webkit-scrollbar {
    width: 12px;
    background-color: #f5f5f5;
  }
  .time-data::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #3a96b8;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 20px;
  }
  /* .select {
    text-align: left;
  } */
  /* .ant-select-selector {
    font-size: 18px;
    color: #2c3e50;
    height: 50px !important;
    align-items: center !important;
    overflow: hidden !important;
  }
  .ant-select-selection-item {
    overflow: initial !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-item {
    line-height: 4px !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 30px !important;
  }
  .ant-select-selection-placeholder {
    color: #2c3e50;
  } */
  /* .ant-select-item .ant-select-item-option {
    font-size: 12px;
    color: #2c3e50;
  }
  .anticon-spin {
    font-size: 24px;
    color: #fff;
    width: 100%;
  } */
  .ant-empty {
    padding-top: 20px;
  }
  .react-calendar__navigation {
    padding: 10px 0px;
    span {
      font-size: 20px;
      padding: 10px;
    }
    .label {
      border: 2px solid #3a96b8;
      border-radius: 50%;
    }
    button {
      text-transform: none;
      /* background: #131f28; */
      background: #f8f9fa;
      /* color: #fff; */
      padding: 5px 18px;
      border: none;
    }
    .react-calendar__navigation__next2-button:hover,
    .react-calendar__navigation__next-button:hover,
    .react-calendar__navigation__prev-button:hover,
    .react-calendar__navigation__prev2-button:hover {
      background-color: #1890ff;
      color: #fff;
      border-radius: 10px;
    }
    span:hover {
      cursor: pointer;
      background-color: #1890ff;
      border-radius: 10px;
      color: #fff;
      padding: 10px;
    }
  }
  .react-calendar__viewContainer {
    button {
      text-transform: none;
      /* background: #131f28; */
      background: #f8f9fa;
      /* color: #fff; */
      color: #1890ff;
      padding: 5px 18px;
      border: none;
    }
    button:focus,
    button:hover {
      cursor: pointer;
      color: #fff;
      background-color: #1890ff;
      border-radius: 10px;
    }
    .react-calendar__month-view__weekdays {
      /* color: #fff; */
      padding: 5px 0px;
    }
  }
  .react-calendar__navigation__arrow {
    font-size: 20px;
  }
  .react-calendar__month-view__weekdays__weekday:hover {
    cursor: pointer;
    background-color: #1890ff;
    color: #fff;
    border-radius: 10px;
  }
  .show-time-data {
    background-color: #3a96b8;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    border: 2px solid transparent;
    h6 {
      margin: 0px;
      color: #fff;
      cursor: pointer;
    }
  }
  .show-time-data:focus,
  .show-time-data:hover {
    cursor: pointer;
    border: 2px solid #3a96b8;
    background-color: #fff;
    h6 {
      color: #3a96b8;
    }
  }
  .react-calendar__tile--active {
    cursor: pointer;
    background-color: #3a96b8 !important;
    color: #fff !important;
    border-radius: 10px;
  }
  .react-calendar__tile:disabled {
    background: #d3d3d357;
    cursor: no-drop;
  }
  .react-calendar__tile:disabled:hover {
    background: #d3d3d357;
    border-radius: 0px;
    cursor: no-drop;
  }
  .ant-card-body {
    border: none;
    border-top: 2px solid #bfb5b5;
    padding: 10px 24px 10px 24px !important;
    h6 {
      font-family: serif;
    }
  }
  .ant-card-head {
    padding: 0px;
  }
  .ant-card-head-title {
    background: linear-gradient(to right, #131f28, #b0e2fb);
    color: #fff;
    font-weight: 600;
  }
  .ant-card-head-title::first-letter {
    text-transform: uppercase;
  }

  /* .main-container >div{
    padding: 10px;
  } */
  @media screen and (max-width: 991px) {
    .time-data {
      background: #131f28;
      padding: 20px 30px;
      box-shadow: 0px 0px 15px 1px #00000066;
      position: relative;
      left: 0px !important;
      border-radius: 15px;
    }
  }
  @media screen and (max-width: 500px) {
    .react-calendar__viewContainer button {
      padding: 5px 6px !important;
    }
    .react-calendar__navigation button {
      padding: 5px 3px !important;
    }
    .ant-row {
      padding: 0px 14px;
    }
    .main-calendar-data {
      padding: 25px 30px !important;
    }
    .time-data {
      background: #131f28;
      padding: 20px 30px;
      box-shadow: 0px 0px 15px 1px #00000066;
      position: relative;
      left: 0px !important;
      border-radius: 15px;
    }
    .show-time-data {
      background-color: #3a96b8;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 50px;
      border: 2px solid transparent;
      h6 {
        margin: 0px;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .show-time-data-active {
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 50px;
    border: 2px solid transparent;
    h6 {
      margin: 0px;
      color: #3a96b8;
      cursor: pointer;
    }
  }
`;
